<div class="manage-generator-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-generator-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-generator-shell__sidebar"
    [class.manage-generator-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-generator-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-generator-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-generator-page">
      <section class="manage-generator-page__panel app-card">
        <div class="manage-generator-page__panel-header">
          <div class="manage-generator-page__heading-copy">
            <h2 class="app-title-serif">Manage Generator</h2>
          </div>

          <button
            type="button"
            class="app-button app-button--primary manage-generator-page__add-button"
            (click)="openAddGeneratorModal()"
          >
            <span class="manage-generator-page__add-icon">+</span>
            <span>Add New Generator</span>
          </button>
        </div>

        <div class="manage-generator-page__panel-body">
          <form class="manage-generator-filters" [formGroup]="filterForm">
            <label class="app-form-field manage-generator-filters__field manage-generator-filters__field--search">
              <span class="app-form-label">Search</span>
              <div class="manage-generator-filters__search">
                <span class="manage-generator-filters__search-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="7"></circle>
                    <path d="m20 20-3.5-3.5"></path>
                  </svg>
                </span>
                <input
                  type="text"
                  class="app-form-input manage-generator-filters__search-input"
                  placeholder="Search"
                  formControlName="search"
                />
              </div>
            </label>

            <label class="app-form-field manage-generator-filters__field" for="manage-generator-substation-filter">
              <span class="app-form-label">Substation</span>
              <p-autocomplete
                inputId="manage-generator-substation-filter"
                [(ngModel)]="filterSubstationSearchTerm"
                [ngModelOptions]="{ standalone: true }"
                [dropdown]="true"
                [suggestions]="filteredFilterSubstationOptions"
                size="compact"
                placeholder="Select Substation"
                (completeMethod)="onFilterSubstationSearchInput($event)"
                (fieldBlur)="onFilterSubstationSearchBlur()"
              ></p-autocomplete>
            </label>

            <label class="app-form-field manage-generator-filters__field" for="manage-generator-province-filter">
              <span class="app-form-label">Province</span>
              <p-autocomplete
                inputId="manage-generator-province-filter"
                [(ngModel)]="filterProvinceSearchTerm"
                [ngModelOptions]="{ standalone: true }"
                [dropdown]="true"
                [suggestions]="filteredFilterProvinceOptions"
                size="compact"
                placeholder="Select Province"
                (completeMethod)="onFilterProvinceSearchInput($event)"
                (fieldBlur)="onFilterProvinceSearchBlur()"
              ></p-autocomplete>
            </label>

            <label class="app-form-field manage-generator-filters__field">
              <span class="app-form-label">Owner</span>
              <select class="app-form-select" formControlName="owner">
                <option [ngValue]="allFilterValue">All Owners</option>
                @for (option of ownerOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </label>

            <label class="app-form-field manage-generator-filters__field">
              <span class="app-form-label">Source Type</span>
              <select class="app-form-select" formControlName="generator_type">
                <option [ngValue]="allFilterValue">All Source Types</option>
                @for (option of generatorTypeOptions; track option.value) {
                  <option [value]="option.value">{{ option.label }}</option>
                }
              </select>
            </label>

            @if (isHydroFilterSelected()) {
              <label class="app-form-field manage-generator-filters__field">
                <span class="app-form-label">Fuel Type</span>
                <select class="app-form-select" formControlName="fuel_type">
                  @for (option of getFilterFuelTypeOptionsForCurrentType(); track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
              </label>
            }

            <div class="app-form-field manage-generator-filters__field manage-generator-filters__field--other-parameter">
              <span class="app-form-label">Other Parameter</span>
              <div class="manage-generator-filters__multiselect" [class.manage-generator-filters__multiselect--open]="otherParameterFilterDropdownOpen">
                <button
                  type="button"
                  class="app-form-select manage-generator-filters__multiselect-control"
                  (click)="toggleOtherParameterFilterDropdown()"
                  [attr.aria-expanded]="otherParameterFilterDropdownOpen"
                  aria-label="Select other parameters"
                >
                  <span>{{ getOtherParameterFilterDisplayValue() || 'All Other Parameters' }}</span>
                  <span class="manage-generator-filters__multiselect-icon" aria-hidden="true"></span>
                </button>
                @if (otherParameterFilterDropdownOpen) {
                  <div class="manage-generator-filters__multiselect-panel" (mousedown)="$event.preventDefault()">
                    @for (option of otherParameterFilterOptions; track option.value) {
                      <label class="manage-generator-filters__multiselect-option">
                        <input
                          type="checkbox"
                          [checked]="isOtherParameterFilterSelected(option.value)"
                          (change)="onOtherParameterFilterSelection(option.value, $any($event.target).checked)"
                        />
                        <span>{{ option.label }}</span>
                      </label>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="manage-generator-filters__clear">
              <button
                type="button"
                class="app-button app-button--secondary equal app-filter-actions__button"
                [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                (click)="clearFilters()"
              >
                Clear
              </button>
            </div>

            <div class="manage-generator-filters__actions">
              <button
                type="button"
                class="app-button app-button--secondary manage-generator-filters__menu-button app-action-menu-trigger"
                [class.manage-generator-filters__menu-button--open]="isGeneratorActionMenuOpen"
                [class.app-action-menu-trigger--open]="isGeneratorActionMenuOpen"
                [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                (click)="toggleGeneratorActionMenu()"
                aria-label="Open generator actions"
              >
                <svg class="manage-generator-filters__menu-icon app-action-menu-trigger__icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <circle cx="12" cy="5.5" r="1.5"></circle>
                  <circle cx="12" cy="12" r="1.5"></circle>
                  <circle cx="12" cy="18.5" r="1.5"></circle>
                </svg>
              </button>

              @if (isGeneratorActionMenuOpen) {
                <div class="manage-generator-filters__menu app-action-menu-panel">
                  <button
                    type="button"
                    class="app-button app-button--secondary manage-generator-filters__menu-item app-action-menu-item"
                    title="Export Data"
                    aria-label="Export Data"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="exportGeneratorData()"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-file-export" aria-hidden="true"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    class="app-button app-button--secondary manage-generator-filters__menu-item app-action-menu-item"
                    title="Download Template"
                    aria-label="Download Template"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="downloadGeneratorTemplate()"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-download" aria-hidden="true"></i>
                    </span>
                  </button>

                  <button
                    type="button"
                    class="app-button app-button--primary manage-generator-filters__menu-item app-action-menu-item"
                    title="Import Data"
                    aria-label="Import Data"
                    [disabled]="isLoading || isExporting || isDownloadingTemplate || isImporting"
                    (click)="triggerGeneratorImportFilePicker(generatorImportInput)"
                  >
                    <span class="app-action-menu-item__icon" aria-hidden="true">
                      <i class="fa-solid fa-file-import" aria-hidden="true"></i>
                    </span>
                  </button>
                </div>
              }
              <input
                #generatorImportInput
                type="file"
                class="manage-generator-filters__import-input"
                accept=".xlsx"
                (change)="onGeneratorImportFileSelected($event)"
              />
            </div>
          </form>

          <div class="manage-generator-page__table-wrap app-table-scroll">
            <table class="manage-generator-table">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th><button type="button" class="manage-sort-button" (click)="toggleSort('generator_name')" [attr.aria-label]="'Sort by Generator Name'"><span>Generator Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('generator_name')" [class.manage-sort-icon--descending]="isSortDescending('generator_name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th><button type="button" class="manage-sort-button" (click)="toggleSort('installed_capacity')" [attr.aria-label]="'Sort by Installed Capacity'"><span>INSTALLED CAPACITY <span class="manage-generator-table__installed-capacity-unit">(kW)</span></span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('installed_capacity')" [class.manage-sort-icon--descending]="isSortDescending('installed_capacity')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>Owner</th>
                  <th><button type="button" class="manage-sort-button" (click)="toggleSort('scada_code')" [attr.aria-label]="'Sort by SCADA Code'"><span>SCADA Code</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('scada_code')" [class.manage-sort-icon--descending]="isSortDescending('scada_code')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>Source Type</th>
                  @if (isFuelTypeColumnVisible()) {
                    <th>Fuel Type</th>
                  }
                  <th><button type="button" class="manage-sort-button" (click)="toggleSort('province')" [attr.aria-label]="'Sort by Province'"><span>Province</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('province')" [class.manage-sort-icon--descending]="isSortDescending('province')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                  <th>Other Parameter</th>
                  <th>Meter</th>
                  <th>Contact</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (isLoading) {
                  <tr>
                    <td [attr.colspan]="getGeneratorTableColspan()" class="manage-generator-page__empty-state">Loading generators...</td>
                  </tr>
                } @else if (filteredGenerators.length) {
                  @for (generator of filteredGenerators; track trackByGeneratorId($index, generator)) {
                    <tr>
                      <td>{{ generator.serial_no ?? '-' }}</td>
                      <td>
                        <app-custom-tooltip [text]="generator.generator_name" [maxLength]="25"></app-custom-tooltip>
                      </td>
                      <td>{{ generator.installed_capacity ?? '-' }}</td>
                      <td>{{ generator.owner || 'NEA' }}</td>
                      <td>{{ generator.scada_station_code || '-' }}</td>
                      <td>{{ generator.generator_type || '-' }}</td>
                      @if (isFuelTypeColumnVisible()) {
                        <td>{{ generator.fuel_type === 'NA' ? '_' : (generator.fuel_type || '-') }}</td>
                      }
                      <td>{{ generator.province_name || getProvinceName(generator.province_id) }}</td>
                      <td>{{ formatOtherParameterForDisplay(generator.other_parameter) }}</td>
                      <td><button type="button" class="manage-generator-page__contact-button" (click)="openGeneratorMetersModal(generator)"><span class="manage-generator-page__contact-count">{{ generator.meter_count ?? 0 }}</span></button></td>
                      <td>
                        <button
                          type="button"
                          class="manage-generator-page__contact-button"
                          (click)="openGeneratorContactsModal(generator)"
                        >
                          <span class="manage-generator-page__contact-count">{{ getGeneratorContactCount(generator) }}</span>
                        </button>
                      </td>
                  
                      <td>
                        <div class="manage-generator-page__actions">
                          <div class="app-row-action-menu">
                            <details class="app-row-action-menu__details">
                              <summary class="app-row-action-menu__toggle" aria-label="Open generator actions">
                                <span class="app-row-action-menu__dots" aria-hidden="true">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewGeneratorModal(generator)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                      <circle cx="12" cy="12" r="2.8"></circle>
                                    </svg>
                                  </span>
                                  <span>View</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditGeneratorModal(generator)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                      <path d="m13.5 6.5 4 4"></path>
                                    </svg>
                                  </span>
                                  <span>Edit</span>
                                </button>
                                <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteGeneratorModal(generator)">
                                  <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                      <path d="M3 6h18"></path>
                                      <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                      <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                      <path d="M10 10v6"></path>
                                      <path d="M14 10v6"></path>
                                    </svg>
                                  </span>
                                  <span>Delete</span>
                                </button>
                              </div>
                            </details>
                          </div>
                        </div>
                      </td>
                    </tr>
                  }
                } @else {
                  <tr>
                    <td [attr.colspan]="getGeneratorTableColspan()" class="manage-generator-page__empty-state">No generators found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          @if (canShowPagination()) {
            <div class="manage-generator-page__pagination">
              <div class="manage-generator-page__pagination-summary">
                <span>{{ getPaginationLabel() }}</span>
              </div>

              <div class="manage-generator-page__pagination-actions">
                <button
                  type="button"
                  class="app-button app-button--secondary manage-generator-page__pagination-button"
                  [disabled]="pagination.page_no <= 1 || isLoading"
                  (click)="goToPreviousPage()"
                >
                  Previous
                </button>

                <div class="manage-generator-page__pagination-pages" aria-label="Pagination pages">
                  @for (page of getPaginationItems(); track $index) {
                    @if (page === -1) {
                      <span class="manage-generator-page__pagination-ellipsis" aria-hidden="true">...</span>
                    } @else {
                      <button
                        type="button"
                        class="manage-generator-page__pagination-page"
                        [class.manage-generator-page__pagination-page--active]="pagination.page_no === page"
                        [disabled]="isLoading"
                        (click)="goToPage(page)"
                      >
                        {{ page }}
                      </button>
                    }
                  }
                </div>

                <button
                  type="button"
                  class="app-button app-button--secondary manage-generator-page__pagination-button"
                  [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0"
                  (click)="goToNextPage()"
                >
                  Next
                </button>
              </div>

              <label class="manage-generator-page__pagination-size">
                <span class="manage-generator-page__pagination-size-label">Rows per page</span>
                <select class="app-form-select manage-generator-page__pagination-select" [formControl]="pageSizeControl">
                  @for (size of pageSizeOptions; track size) {
                    <option [ngValue]="size">{{ size }}/Page</option>
                  }
                </select>
              </label>
            </div>
          }
        </div>
      </section>
    </main>
  </div>

  @if (generatorModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-generator-modal" open>
        <div class="manage-generator-modal__header">
          <div>
            <h3 class="app-title-serif">
              {{ modalMode === 'edit' ? 'Edit Generator' : modalMode === 'view' ? 'View Generator' : 'Add New Generator' }}
            </h3>
          </div>

          <button
            type="button"
            class="app-button app-button--icon manage-generator-modal__close"
            aria-label="Close modal"
            (click)="closeGeneratorModal()"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="generatorForm" (ngSubmit)="saveGenerator()">
          <div class="manage-generator-modal__body">
            @if (submitErrorMessage) {
              <section class="manage-generator-modal__alert app-form-error">{{ submitErrorMessage }}</section>
            }

            <div class="manage-generator-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Name Of Power Plant <span class="manage-generator-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="Enter Name" formControlName="generator_name" />
                @if (isRequiredFieldInvalid('generator_name')) {
                  <section class="app-form-error">Generator name is required</section>
                }
              </label>

               <div class="app-form-field">
                <span class="app-form-label">Developer Name</span>
                <p-autocomplete
                  [(ngModel)]="entitySearchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  [dropdown]="true"
                  [suggestions]="filteredEntityOptions"
                  placeholder="Select Developer Name"
                  [disabled]="modalMode === 'view'"
                  (completeMethod)="onEntitySearchInput($event)"
                  (fieldBlur)="onEntitySearchBlur()"
                ></p-autocomplete>
              </div>

              <label class="app-form-field">
                <span class="app-form-label">Owner</span>
                <select class="app-form-select" formControlName="owner">
                  @for (option of ownerOptions; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Delivery Point</span>
                <input class="app-form-input" type="text" placeholder="Delivery point" formControlName="delivery_point" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Corridor</span>
                <input class="app-form-input" type="text" placeholder="Corridor" formControlName="corridor" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">PPA Date</span>
                <input class="app-form-input" type="date" formControlName="ppa_date" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Source Type <span class="manage-generator-modal__required">*</span></span>
                <select class="app-form-select" formControlName="generator_type">
                  <option [ngValue]="''">Select Type</option>
                  @for (option of generatorTypeOptions; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
                @if (isRequiredFieldInvalid('generator_type')) {
                  <section class="app-form-error">Generator type is required</section>
                }
              </label>

              @if (getFuelTypeOptionsForCurrentType().length) {
                <label class="app-form-field">
                  <span class="app-form-label">Fuel Type</span>
                  <select class="app-form-select" formControlName="fuel_type">
                    <option [ngValue]="''">Select Fuel Type</option>
                    @for (option of getFuelTypeOptionsForCurrentType(); track option.value) {
                      <option [value]="option.value">{{ option.label }}</option>
                    }
                  </select>
                </label>
              }

              @if (modalMode !== 'edit') {
                <label class="app-form-field">
                  <span class="app-form-label">Project Unique Code</span>
                  <input class="app-form-input" type="text" placeholder="Project unique code" formControlName="project_unique_code" maxlength="100" />
                </label>
              }

              <label class="app-form-field">
                <span class="app-form-label">SCADA Station Code</span>
                <input
                  class="app-form-input"
                  type="text"
                  placeholder="SCADA station code"
                  formControlName="scada_station_code"
                  maxlength="50"
                  (input)="onScadaStationCodeInput($event)"
                />
              </label>

              <div class="app-form-field">
                <span class="app-form-label">Connecting Substation</span>
                <p-autocomplete
                  [(ngModel)]="substationSearchTerm"
                  [ngModelOptions]="{ standalone: true }"
                  [dropdown]="true"
                  [suggestions]="filteredSubstationOptions"
                  placeholder="Select Substation"
                  [disabled]="modalMode === 'view'"
                  (completeMethod)="onSubstationSearchInput($event)"
                  (fieldBlur)="onSubstationSearchBlur()"
                ></p-autocomplete>
              </div>

              <label class="app-form-field">
                <span class="app-form-label">Connecting Voltage Level (kV)</span>
                <select class="app-form-select" formControlName="connecting_voltage_level_id">
                  <option [ngValue]="null">Select Voltage Level</option>
                  @for (voltageLevel of voltageLevelOptions; track voltageLevel.id) {
                    <option [ngValue]="voltageLevel.id">{{ voltageLevel.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Voltage Level (kV)</span>
                <select class="app-form-select" formControlName="voltage_level_id">
                  <option [ngValue]="null">Select Voltage Level</option>
                  @for (voltageLevel of voltageLevelOptions; track voltageLevel.id) {
                    <option [ngValue]="voltageLevel.id">{{ voltageLevel.name }}</option>
                  }
                </select>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Installed Capacity (kW)</span>
                <input class="app-form-input" type="text" placeholder="Installed capacity" formControlName="installed_capacity" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Generator Capacity (kW)</span>
                <input class="app-form-input" type="text" placeholder="Generator capacity" formControlName="capacity" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">No of Units</span>
                <input class="app-form-input" type="number" placeholder="No of units" formControlName="no_of_units" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Log Sheet? <span class="manage-generator-modal__required">*</span></span>
                <select class="app-form-select manage-generator-modal__compact-select" formControlName="log_sheet">
                  <option [ngValue]="''">-- Select --</option>
                  @for (option of logSheetOptions; track option.value) {
                    <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
                @if (isRequiredFieldInvalid('log_sheet')) {
                  <section class="app-form-error">Log sheet is required</section>
                }
              </label>

              <label class="app-form-field manage-generator-modal__field--wide manage-generator-modal__file-field">
                <span class="app-form-label">File</span>
                <div class="manage-generator-modal__file-row">
                  <input #fileInput class="manage-generator-modal__file-native" type="file" [disabled]="modalMode === 'view'" (change)="onFileSelected($event)" />
                  <button
                    type="button"
                    class="app-form-input manage-generator-modal__file-picker"
                    [disabled]="modalMode === 'view'"
                    (click)="fileInput.click()"
                    [class.manage-generator-modal__file-picker--selected]="hasAnyFile()"
                  >
                    {{ getDisplayedFileLabel() || 'Choose File' }}
                  </button>
                  <div class="manage-generator-modal__file-actions" *ngIf="hasAnyFile()">
                    <button
                      type="button"
                      class="app-button app-button--secondary manage-generator-modal__file-button"
                      [disabled]="!hasFilePreview()"
                      (click)="previewSelectedFile()"
                    >
                      Preview
                    </button>
                    <button
                      type="button"
                      class="app-button app-button--secondary manage-generator-modal__file-button manage-generator-modal__file-button--danger"
                      [disabled]="modalMode === 'view'"
                      (click)="removeSelectedFile(fileInput)"
                    >
                      X
                    </button>
                  </div>
                </div>
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Other Parameter</span>
                <div class="manage-generator-modal__multiselect" [class.manage-generator-modal__multiselect--open]="otherParameterDropdownOpen">
                  <button
                    type="button"
                    class="app-form-input manage-generator-modal__multiselect-control"
                    [disabled]="modalMode === 'view'"
                    (click)="toggleOtherParameterDropdown()"
                    [attr.aria-expanded]="otherParameterDropdownOpen"
                    aria-label="Select other parameters"
                  >
                    <span class="manage-generator-modal__multiselect-value">
                      {{ getOtherParameterDisplayValue() || 'Select Other Parameter' }}
                    </span>
                    <svg
                      class="manage-generator-modal__multiselect-icon"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      aria-hidden="true"
                    >
                      <path d="m6 9 6 6 6-6"></path>
                    </svg>
                  </button>

                  @if (otherParameterDropdownOpen) {
                    <div class="manage-generator-modal__multiselect-panel" (mousedown)="$event.preventDefault()">
                      @for (option of otherParameterOptions; track option) {
                        <label class="manage-generator-modal__multiselect-option">
                          <input
                            type="checkbox"
                            [disabled]="modalMode === 'view'"
                            [checked]="isOtherParameterSelected(option)"
                            (change)="onOtherParameterSelection(option, $any($event.target).checked)"
                          />
                          <span>{{ option }}</span>
                        </label>
                      }
                    </div>
                  }
                </div>
              </label>
              <div class="app-form-field manage-generator-modal__field--inline">
                <span class="app-form-label">Act as a Substation</span>
                <label class="manage-generator-modal__switch">
                  <input type="checkbox" formControlName="act_as_substation" />
                  <span>Yes</span>
                </label>
              </div>
            </div>
            <br>

            <div class="manage-generator-modal__sections">
              <fieldset class="manage-generator-modal__section">
                <legend>Our Address</legend>
                <div class="manage-generator-modal__section-grid">
                  <label class="app-form-field" for="manage-generator-province">
                    <span class="app-form-label">Province <span class="manage-generator-modal__required">*</span></span>
                    <p-autocomplete
                      [inputId]="'manage-generator-province'"
                      [(ngModel)]="provinceSearchTerm"
                      [ngModelOptions]="{ standalone: true }"
                      [dropdown]="true"
                      [suggestions]="filteredProvinceOptions"
                      placeholder="Select Province"
                      [disabled]="modalMode === 'view'"
                      (completeMethod)="onProvinceSearchInput($event)"
                      (fieldBlur)="onProvinceSearchBlur()"
                    ></p-autocomplete>
                    @if (isRequiredFieldInvalid('province_id')) {
                      <section class="app-form-error">Province is required</section>
                    }
                  </label>

                  <label class="app-form-field" for="manage-generator-district">
                    <span class="app-form-label">District <span class="manage-generator-modal__required">*</span></span>
                    <p-autocomplete
                      [inputId]="'manage-generator-district'"
                      [(ngModel)]="districtSearchTerm"
                      [ngModelOptions]="{ standalone: true }"
                      [dropdown]="true"
                      [suggestions]="filteredDistrictOptions"
                      placeholder="Select District"
                      [disabled]="modalMode === 'view'"
                      (completeMethod)="onDistrictSearchInput($event)"
                      (fieldBlur)="onDistrictSearchBlur()"
                    ></p-autocomplete>
                    @if (isRequiredFieldInvalid('district_id')) {
                      <section class="app-form-error">District is required</section>
                    }
                  </label>

                  <label class="app-form-field" for="manage-generator-local-level">
                    <span class="app-form-label">Local Level</span>
                    <p-autocomplete
                      [inputId]="'manage-generator-local-level'"
                      [(ngModel)]="localLevelSearchTerm"
                      [ngModelOptions]="{ standalone: true }"
                      [dropdown]="true"
                      [suggestions]="filteredLocalLevelOptions"
                      placeholder="Select Local Level"
                      [disabled]="modalMode === 'view'"
                      (completeMethod)="onLocalLevelSearchInput($event)"
                      (fieldBlur)="onLocalLevelSearchBlur()"
                    ></p-autocomplete>
                  </label>
                </div>
              </fieldset>

              <fieldset class="manage-generator-modal__section">
                <legend>Our Location</legend>
                <div class="manage-generator-modal__section-grid manage-generator-modal__section-grid--location">
                  <label class="app-form-field">
                    <span class="app-form-label">Latitude</span>
                    <input class="app-form-input" type="text" placeholder="Latitude" formControlName="latitude" />
                  </label>

                  <label class="app-form-field">
                    <span class="app-form-label">Longitude</span>
                    <input class="app-form-input" type="text" placeholder="Longitude" formControlName="longitude" />
                  </label>
                </div>
              </fieldset>
              <section class="manage-generator-modal__section manage-generator-modal__contacts">
                <div class="manage-generator-modal__section-header manage-generator-modal__contacts-header">
                  <h3 class="manage-generator-modal__section-title">Contact Details</h3>
                  @if (modalMode !== 'view') {
                    <button type="button" class="app-button app-button--primary manage-generator-modal__add-more" (click)="addContactDetailRow()">+ Add More</button>
                  }
                </div>

                <div class="manage-generator-modal__contact-list" formArrayName="contact_details">
                  @for (contactGroup of contactDetailControls; track $index) {
                    <div class="manage-generator-modal__contact-row" [formGroupName]="$index">
                      <div class="manage-generator-modal__contact-index">{{ $index + 1 }}</div>
                      <label class="app-form-field">
                        <span class="app-form-label">Contact Person</span>
                        <input class="app-form-input" type="text" placeholder="Contact person" formControlName="person_name" maxlength="255" />
                        @if (isContactDetailPersonInvalid($index)) {
                          <section class="app-form-error">Contact person can contain only letters and spaces</section>
                        }
                      </label>

                      <label class="app-form-field">
                        <span class="app-form-label">Email</span>
                        <input class="app-form-input" type="email" placeholder="Email address" formControlName="email" />
                        @if (isContactDetailEmailInvalid($index)) {
                          <section class="app-form-error">Enter a valid email address</section>
                        }
                      </label>

                      <label class="app-form-field">
                        <span class="app-form-label">Mobile No</span>
                        <input class="app-form-input" type="text" inputmode="numeric" placeholder="Mobile number" formControlName="mobile_no" maxlength="10" (input)="onContactMobileNumberInput($index, $event)" />
                        @if (isContactDetailMobileInvalid($index)) {
                          <section class="app-form-error">Mobile number must contain exactly 10 digits</section>
                        }
                      </label>

                      <input type="hidden" formControlName="designation" />
                      <input type="hidden" formControlName="id" />
                      <input type="hidden" formControlName="is_portal_user" />

                      <div class="manage-generator-modal__contact-actions">
                        <button
                          type="button"
                          class="app-button app-button--icon manage-generator-modal__contact-remove"
                          aria-label="Remove contact row"
                          [disabled]="modalMode === 'view' || isContactDetailPortalUser($index)"
                          (click)="removeContactDetailRow($index)"
                        >
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                            <path d="M6 6 18 18"></path>
                            <path d="M18 6 6 18"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </section>
            </div>
          </div>

          <div class="manage-generator-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeGeneratorModal()">{{ modalMode === 'view' ? 'Close' : 'Cancel' }}</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (contactModalOpen && selectedGeneratorContacts) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-generator-modal manage-generator-modal--contacts" open>
        <div class="manage-generator-modal__header">
          <div>
            <h3 class="app-title-serif">Contact Persons</h3>
            <p class="manage-generator-modal__subtitle">{{ selectedGeneratorContacts.generator_name }}</p>
          </div>

          <button
            type="button"
            class="app-button app-button--icon manage-generator-modal__close"
            aria-label="Close contacts modal"
            (click)="closeGeneratorContactsModal()"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <div class="manage-generator-modal__body manage-generator-modal__body--contacts">
          <div class="manage-generator-modal__contacts-summary">
            <span>{{ getGeneratorContactCount(selectedGeneratorContacts) }} contact(s)</span>
          </div>

          <div class="manage-generator-modal__contact-list manage-generator-modal__contact-list--popup">
            @if (getGeneratorContactRows(selectedGeneratorContacts).length) {
              @for (contact of getGeneratorContactRows(selectedGeneratorContacts); track trackByGeneratorContactId($index, contact)) {
                <section class="manage-generator-modal__contact-card">
                  <div class="manage-generator-modal__contact-card-main">
                    <div class="manage-generator-modal__contact-avatar">{{ $index + 1 }}</div>

                    <div class="manage-generator-modal__contact-card-copy">
                      <h4>{{ contact.person_name || '-' }}</h4>
                      <p>{{ contact.designation || 'Contact person' }}</p>
                      @if (contact.username) {
                        <span class="manage-generator-modal__contact-username">{{ contact.username }}</span>
                      }
                    </div>
                  </div>

                  <div class="manage-generator-modal__contact-card-meta">
                    <div class="manage-generator-modal__contact-card-details">
                      <div>
                        <span>Email</span>
                        <strong>{{ contact.email || '-' }}</strong>
                      </div>
                      <div>
                        <span>Mobile</span>
                        <strong>{{ contact.mobile_no || '-' }}</strong>
                      </div>
                    </div>

                    <div class="manage-generator-modal__contact-card-actions">
                      @if (hasPortalUserAccess(contact)) {
                        <span class="manage-generator-modal__contact-badge manage-generator-modal__contact-badge--success">Portal user</span>
                      } @else {
                        <button
                          type="button"
                          class="app-button app-button--primary manage-generator-modal__credential-button"
                          [disabled]="isCreatingContactCredentials || contact.id <= 0"
                          (click)="createContactLoginCredentials(contact)"
                        >
                          Create Login Credential
                        </button>
                      }
                    </div>
                  </div>
                </section>
              }
            } @else {
              <div class="manage-generator-modal__empty">No contact persons found.</div>
            }
          </div>
        </div>

        <div class="manage-generator-modal__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeGeneratorContactsModal()">Close</button>
        </div>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedGenerator) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-generator-delete">
        <div class="manage-generator-delete__header">
          <div class="manage-generator-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Generator</h3>
            <p>This action cannot be undone</p>
          </div>
        </div>

        <p class="manage-generator-delete__copy">
          Are you sure you want to delete <strong>{{ selectedGenerator.generator_name }}</strong>?
        </p>

        <div class="manage-generator-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }

  @if (generatorMetersModalOpen && selectedGeneratorForMeters) {
    <div class="app-modal-backdrop"><dialog class="app-modal manage-substation-generators-modal" open>
      <div class="manage-substation-generators-modal__header"><div class="manage-substation-generators-modal__header-copy"><h3 class="app-title-serif">Meters</h3><p>{{ selectedGeneratorForMeters.generator_name }} · {{ generatorMeters.length }} assigned meters</p></div><button type="button" class="app-button app-button--primary" (click)="openMeterPickerModal()">Assign New Meter</button><button type="button" class="manage-substation-generators-modal__close" aria-label="Close meters modal" (click)="closeGeneratorMetersModal()">×</button></div>
      <div class="manage-substation-generators-modal__body">@if (isGeneratorMetersLoading) { <div class="manage-substation-generators-modal__empty">Loading assigned meters...</div> } @else if (generatorMeters.length) { <div class="manage-substation-generators-modal__table-wrap app-table-scroll"><table class="manage-substation-generators-modal__table"><thead><tr><th>S.No.</th><th>Meter Number</th><th>Manufacturer Name</th><th>Meter Type</th><th>MF Value</th><th>Action</th></tr></thead><tbody>@for (meter of generatorMeters; track meter.id) { <tr><td>{{ meter.serial_no }}</td><td>{{ meter.meter_no }}</td><td>{{ meter.mfr_name }}</td><td>{{ meter.meter_type }}</td><td>{{ meter.mf_value ?? '-' }}</td><td><button type="button" class="app-button app-button--icon manage-substation-generators-modal__action manage-substation-generators-modal__action--remove" (click)="unassignMeter(meter)">×</button></td></tr> }</tbody></table></div> } @else { <div class="manage-substation-generators-modal__empty">No meters assigned to this generator.</div> }</div>
      <div class="manage-substation-generators-modal__footer"><button type="button" class="app-button app-button--secondary" (click)="closeGeneratorMetersModal()">Close</button></div>
    </dialog></div>
  }
  @if (generatorMeterPickerModalOpen && selectedGeneratorForMeters) {
    <div class="app-modal-backdrop"><dialog class="app-modal manage-substation-generator-picker-modal" open>
      <div class="manage-substation-generators-modal__header"><div class="manage-substation-generators-modal__header-copy"><h3 class="app-title-serif">Assign New Meter</h3><p>{{ selectedGeneratorForMeters.generator_name }} · Select meters to assign</p></div><button type="button" class="app-button app-button--primary" (click)="openAddMeterModal()">Add New Meter</button><button type="button" class="manage-substation-generators-modal__close" aria-label="Close meter picker" (click)="closeMeterPickerModal()">×</button></div>
      <div class="manage-substation-generators-modal__body">@if (isAvailableMetersLoading) { <div class="manage-substation-generators-modal__empty">Loading available meters...</div> } @else { <label class="app-form-field manage-substation-generator-picker-modal__search"><span class="app-form-label">Search</span><div class="manage-generator-filters__search"><span class="manage-generator-filters__search-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg></span><input class="app-form-input manage-generator-filters__search-input" type="search" [formControl]="availableMeterSearchControl" placeholder="Search Meter Number" /></div></label>@if (availableMeters.length) { <div class="manage-substation-generators-modal__table-wrap app-table-scroll"><table class="manage-substation-generators-modal__table manage-substation-generators-modal__table--action-first"><thead><tr><th>Action</th><th>S.No.</th><th>Meter Number</th><th>Manufacturer Name</th><th>Meter Type</th><th>MF Value</th></tr></thead><tbody>@for (meter of availableMeters; track meter.id) { <tr><td><input type="checkbox" [checked]="isAvailableMeterSelected(meter.id)" (change)="updateAvailableMeterSelection(meter.id, $event)" /></td><td>{{ meter.serial_no }}</td><td>{{ meter.meter_no }}</td><td>{{ meter.mfr_name }}</td><td>{{ meter.meter_type }}</td><td>{{ meter.mf_value ?? '-' }}</td></tr> }</tbody></table></div> } @else { <div class="manage-substation-generators-modal__empty">{{ availableMeterSearchControl.value ? 'No meters match the search.' : 'No unassigned meters available.' }}</div> }@if (canShowAvailableMeterPagination()) { <div class="manage-generator-page__pagination manage-substation-generator-picker-modal__pagination"><div class="manage-generator-page__pagination-summary"><span>{{ getAvailableMeterPaginationLabel() }}</span></div><div class="manage-generator-page__pagination-actions"><button type="button" class="app-button app-button--secondary manage-generator-page__pagination-button" [disabled]="availableMeterPagination.page_no <= 1 || isAvailableMetersLoading" (click)="goToPreviousAvailableMeterPage()">Previous</button><div class="manage-generator-page__pagination-pages" aria-label="Available meter pages">@for (page of getAvailableMeterPaginationItems(); track $index) { @if (page === -1) { <span class="manage-generator-page__pagination-ellipsis" aria-hidden="true">...</span> } @else { <button type="button" class="manage-generator-page__pagination-page" [class.manage-generator-page__pagination-page--active]="availableMeterPagination.page_no === page" [disabled]="isAvailableMetersLoading" (click)="goToAvailableMeterPage(page)">{{ page }}</button> } }</div><button type="button" class="app-button app-button--secondary manage-generator-page__pagination-button" [disabled]="availableMeterPagination.page_no >= availableMeterPagination.total_pages || isAvailableMetersLoading || availableMeterPagination.total_pages === 0" (click)="goToNextAvailableMeterPage()">Next</button></div><label class="manage-generator-page__pagination-size"><span class="manage-generator-page__pagination-size-label">Rows per page</span><select class="app-form-select manage-generator-page__pagination-select" [formControl]="availableMeterPageSizeControl">@for (size of pageSizeOptions; track size) { <option [ngValue]="size">{{ size }}/Page</option> }</select></label></div>} }</div>
      <div class="manage-substation-generators-modal__footer"><button type="button" class="app-button app-button--secondary" (click)="closeMeterPickerModal()">Cancel</button><button type="button" class="app-button app-button--primary" [disabled]="!selectedAvailableMeterIds.size || isMeterAssignmentSaving" (click)="saveSelectedMeters()">Save</button></div>
    </dialog></div>
  }
  @if (addMeterModalOpen && selectedGeneratorForMeters) { <app-meter-add-modal (closed)="closeAddMeterModal()" (saved)="onMeterCreated()"></app-meter-add-modal> }
</div>
